import collision from '@/assets/generated/world/cave/cave-collision.json';
import zones from '@/assets/generated/world/cave/cave-zones.json';
import { translatedRegionData, type SerializedMapData, type SerializedZoneData } from './region-map-data';

const data = translatedRegionData(
  collision as unknown as SerializedMapData,
  zones as unknown as SerializedZoneData,
  0,
  1920,
  2,
);
export const CAVE_COLLISION = data.collision;
export const CAVE_ZONES = data.zones;
